import React from 'react';
import ReactDOM from 'react-dom';

import './i18n';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';

// Suppress ResizeObserver errors (common in React apps, usually harmless)
const resizeObserverErrorHandler = (e: ErrorEvent) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message.includes('ResizeObserver loop')) {
        const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay');
        if (resizeObserverErrDiv) {
            resizeObserverErrDiv.style.display = 'none';
        }
        e.stopImmediatePropagation();
        e.preventDefault();
        return false;
    }
};
window.addEventListener('error', resizeObserverErrorHandler);

// Suppress unhandled promise rejections for ResizeObserver
window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message?.includes('ResizeObserver loop')) {
        e.preventDefault();
    }
});

// Also suppress in console
const consoleError = console.error;
console.error = (...args: any[]) => {
    if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop')) {
        return;
    }
    consoleError(...args);
};

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
